"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _RequestTool = require("../../../../../RequestTool");
var _SubMenuItem = require("../../../../../SubMenuItem");
const RequestToolItem = _ref => {
  let {
    code,
    metadata = {},
    text,
    icon,
    ModalComp
  } = _ref;
  const [isModalOpen, setIsModalOpen] = _react.default.useState(false);
  const open = () => {
    setIsModalOpen(true);
  };
  const onDismiss = () => {
    setIsModalOpen(false);
  };
  const afterSubmit = () => {
    setIsModalOpen(false);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SubMenuItem.SubMenuItem, {
    type: "SalesForce",
    showing: true,
    openModal: open,
    metadata: metadata,
    code: code,
    text: text,
    icon: icon
  }), isModalOpen && /*#__PURE__*/_react.default.createElement(_RequestTool.RequestToolModal, {
    saleForceCode: code,
    productInterest: metadata === null || metadata === void 0 ? void 0 : metadata.ProductInterestPredefinedValue,
    onDismiss: onDismiss,
    afterSubmit: afterSubmit,
    ModalComp: ModalComp
  }));
};
var _default = exports.default = RequestToolItem;